async function fetchVisitData(searchParams) {
  const url = `${process.env.REACT_APP_API_URI}/api/visit?${searchParams.toString()}`;
  try {
    const response = await fetch(url, {
      method: "GET",
      credentials: "include",
    });
    return await response.json();
  } catch (error) {
    throw new Error(`Error on visit: ${error.message}`);
  }
}

async function fetchInitForm(trx, payloadObj, searchParams) {
  const url = `${process.env.REACT_APP_API_URI}/api/v2/init_form?utid=degree-programs&_trx=${trx}&${searchParams.toString()}`;
  try {
    const data = await fetch(url, {
      method: "GET",
      credentials: "include",
    });
    const initData = await data.json();
    const firstKey = Object.keys(initData.location)[0];
    const {stateCode} = initData.location[firstKey];
    const formConfigData = await fetchFormConfig(initData.fsid, stateCode, payloadObj, searchParams);
    return {initData, formConfigData};
  } catch (err) {
    throw new Error(`Error on init: ${err.message}`);
  }
}

async function fetchFormConfig(FormSubmissionId, stateCode, payload, searchParams) {
  const url = `${process.env.REACT_APP_API_URI}/api/v2/get_form?utid=degree-programs&fsid=${FormSubmissionId}`;
  const requestOptions = {
    method: "POST",
    credentials: "include",
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({
      url_params: `${searchParams.toString()}`,
      state: stateCode.toUpperCase(),
      ...payload,
    }),
  };
  try {
    const data = await fetch(url, requestOptions);
    return await data.json();
  } catch (err) {
    throw new Error(`Error on config: ${err.message}`);
  }
}

export {fetchVisitData, fetchInitForm};
